type Dispatch = (tipo: string, valor: unknown, opcoes?: { root: boolean }) => Promise<unknown>

export const revalidarCatalogosAposEscrita = (dispatch: Dispatch, modulos: readonly string[]): void => {
  for (const modulo of modulos) {
    void dispatch(`common/${modulo}/fetchItems`, { fullReload: true }, { root: true }).catch(() => undefined)
  }
}
